import React from 'react';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { IssuanceDocumentFileListPage } from './documentFileList';
import { IssuanceDocumentFolderListPage } from './documentFolderList';
import { DocumentPageType, IssuanceDocumentProps, useIssuanceDocument } from './hooks';
import { useLocation, useNavigate } from 'react-router-dom';
import { SearchBox } from 'views/mutual/searchBox';
import { LoadingContainer, LoadingSize } from 'views/mutual/loading';
import { NotFoundData, NotFoundDataBackPageType } from 'views/mutual/notFoundData';
import { PagePath } from 'constants/pagePath';
import { ComponentControl } from 'views/mutual/componentControl';

const useQueryToIssuanceDocumentProps = (): IssuanceDocumentProps => {
  const { search } = useLocation();
  return React.useMemo(() => {
    const params = new URLSearchParams(search);
    const folderId = params.get('id');
    const symbolName = params.get('name');

    if (symbolName && folderId) {
      return {
        kind: 'symbolName',
        folderId,
        symbolName,
      };
    } else {
      return {
        kind: 'id',
        folderId,
      };
    }
  }, [search]);
};

export const IssuanceDocument = () => {
  const navigate = useNavigate();
  const props = useQueryToIssuanceDocumentProps();
  const { currentFolderId, currentFolderName, searchKeyWord, documentPageType, documentFolderList, onFolderSelect } =
    useIssuanceDocument(props);
  useCustomLocationName(currentFolderName);

  if (documentFolderList.fetching) {
    return (
      <LoadingContainer isLoading={documentFolderList.fetching} size={LoadingSize.Medium}>
        <></>
      </LoadingContainer>
    );
  }

  if (
    !documentFolderList.data?.GetIssuanceDocumentFolderList?.Own &&
    !documentFolderList.data?.GetIssuanceDocumentFolderList?.Data
  ) {
    return (
      <NotFoundData
        backPageType={{
          kind: 'target',
          label: '交付書面TOPに戻る',
          navigate: () => navigate(PagePath.IssuanceDocument),
        }}
      />
    );
  }

  switch (documentPageType) {
    case DocumentPageType.Folder:
      return (
        <ComponentControl
          componentName={IssuanceDocumentFolderListPage}
          noDataMessege="表示できるファイルはありません"
          isLoading={documentFolderList.fetching}
          items={documentFolderList.data?.GetIssuanceDocumentFolderList?.Data || []}
          onFolderSelect={onFolderSelect}
        />
      );
    case DocumentPageType.File:
      return <IssuanceDocumentFileListPage folderId={currentFolderId!} defaultKeyWord={searchKeyWord} />;
  }
};
